import $ from "jquery";
import { application } from "../application/application";
import { courseDashboardFilters } from "./courseDashboardFilters";
import { courseSearch } from "./courseSearch";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

let coursesTable;
let dataSet = [];
let currentPage = 0;
const pageSize = 20;
let hasNextPage;
const tableColumns = [
    "",
    "CourseId",
    "SiteName",
    "Region",
    "Program",
    "CourseType",
    "CourseEdition",
    "Dates",
    "CourseLength",
    "Status"
];

function init() {
    buildTable();
    setNextPrevButtonEnabled();

    forms.showSpinner();
    courseDashboardFilters
        .doSetup()
        .done(function() {
            populateTable();
            setEvents();
            forms.hideSpinner();
        })
        .fail(function() {
            services.notificationService.error(
                "An unexpected error has occurred. Please try again later."
            );
            forms.hideSpinner();
        });
}

function setEvents() {
    $("#btnDownloadExcelCurrPage").click(function() {
        $(this).attr("href", exportCoursesToExcel(false));
    });
    $("#btnDownloadExcelAll").click(function() {
        $(this).attr("href", exportCoursesToExcel(true));
    });

    function exportCoursesToExcel(getAll) {
        let source = "";
        if (getAll) source = "/Courses/GetCourseSearchExcel" + "/-1/?";
        else source = "/Courses/GetCourseSearchExcel" + "/" + currentPage + "/?";
        const sourceWithParams = (source += $.param(
            courseDashboardFilters.getQueryStringFilters()
        ).replace(/%5B%5D/g, ""));
        if ($("#coursesTable > tbody > tr td:contains('No data available in table')").length >= 1) {
            services.notificationService.error(
                "No courses to export. Please try to update the search criteria."
            );
            return "";
        } else {
            return sourceWithParams;
        }
    }

    $("#next").click(goNextPage);

    $("#previous").click(goPreviousPage);

    $("#applyFilters").click(applyFilters);

    $("#clearFilters").click(clearFilters);

    if ($("#IsTransferStudentSection").val() === "True") {
        $(document).on("dblclick", "#coursesTable tbody tr", goToConfirmTransfer);
    } else {
        $(document).on("dblclick", "#coursesTable tbody tr", goToCourse);
    }

    $(".sorting, .sorting_asc, .sorting_desc").click(function(e) {
        const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
        $(".sorting, .sorting_asc, .sorting_desc")
            .removeClass()
            .addClass("sorting");

        if (asc) {
            $(this)
                .removeClass("sorting")
                .removeClass("sorting_desc")
                .addClass("sorting_asc");
        } else {
            $(this)
                .removeClass("sorting")
                .removeClass("sorting_asc")
                .addClass("sorting_desc");
        }
        $(".sorting, .sorting_asc, .sorting_desc")
            .not($(this))
            .removeClass(".sorting_asc")
            .removeClass(".sorting_desc")
            .addClass("sorting");

        const sort = {
            column: tableColumns[coursesTable.column(this).index()],
            columnIndex: coursesTable.column(this).index(),
            desc: $(this).hasClass("sorting_desc")
        };
        courseDashboardFilters.setSort(sort.column, sort.columnIndex, sort.desc);
        currentPage = 0;
        populateTable();
    });

    $(document).on("submit", "#course-search", function(e) {
        e.preventDefault();
        console.log("submit-course-search");
        applyFilters();
    });
}

function buildDataSet(courses) {
    dataSet = [];
    for (let i = 0; i <= pageSize && i < courses.length; i++) {
        dataSet.push([
            courses[i].id,
            courses[i].id,
            courses[i].siteName,
            courses[i].regionNumber,
            courses[i].program,
            courses[i].courseType,
            courses[i].courseEdition,
            courses[i].dates,
            courses[i].courseLength,
            courses[i].status
        ]);
    }
    hasNextPage = courses.length > pageSize;
}

function buildTable() {
    if (coursesTable !== undefined) {
        coursesTable.destroy();
    }
    coursesTable = $("#coursesTable").DataTable({
        serverSide: false, // for process server side
        filter: false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        data: dataSet,
        bLengthChange: false,
        bPaginate: false,
        PageLength: 20,
        bInfo: false,
        ordering: false,
        columnDefs: [
            {
                targets: 0,
                name: "Id",
                visible: false
            },
            {
                targets: 1,
                name: "Serial #"
            },
            {
                targets: 2,
                name: "Site"
            },
            {
                targets: 3,
                name: "Region"
            },
            {
                targets: 4,
                name: "Program"
            },
            {
                targets: 5,
                name: "Type"
            },
            {
                targets: 6,
                name: "Edition"
            },
            {
                targets: 7,
                name: "Dates"
            },
            {
                targets: 8,
                name: "Length"
            },
            {
                targets: 9,
                name: "Status"
            }
        ]
    });
    $("#coursesTable [data-toggle='tooltip']").tooltip();
    courseDashboardFilters.setCoursesTable(coursesTable);
}

function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 0) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    populateTable();
}

function goPreviousPage() {
    if (currentPage === 0) return;
    currentPage--;
    populateTable();
}

function applyFilters() {
    currentPage = 0;
    courseDashboardFilters.setFilters();
    populateTable();
}

function clearFilters() {
    currentPage = 0;
    courseDashboardFilters.clearFilters();
    populateTable();
}

function populateTable() {
    const filters = courseDashboardFilters.getFilters();
    return $.Deferred(function(def) {
        courseSearch.getCourses(currentPage, filters).done(function(results) {
            buildDataSet(results.courses);
            setNextPrevButtonEnabled();
            coursesTable.clear();
            coursesTable.rows
                .add(dataSet)
                .columns.adjust()
                .draw();
            $("#coursesTable [data-toggle='tooltip']").tooltip();
            def.resolve();
        });
    }).promise();
}

function goToCourse() {
    const data = coursesTable.row(this).data();
    if (data === undefined) {
        return;
    }
    forms.showSpinner();
    window.location.href = application.baseUrl + "/course/index/" + data[0];
}

function goToConfirmTransfer() {
    const data = coursesTable.row(this).data();
    if (data === undefined) {
        return;
    }
    const toCourseId = data[0];
    $("#TransferToCourseId").val(toCourseId);
    const $modal = $("#ConfirmTransferModal");
    $modal.find("span").text(toCourseId);
    $modal.modal("show");
}

export const courseDashboard = {
    init: init
};
